import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

import api from "@/api/datav";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async total(params: any) {
    return api.total(params);
  }

  @Action
  async maptotal(params: any) {
    return api.maptotal(params);
  }

  @Action
  async ai(params: any) {
    return api.ai(params);
  }

  @Action
  async activityLog(params: any) {
    return api.activityLog(params);
  }

  @Action
  async activityLog1(params: any) {
    return api.activityLog1(params);
  }

  @Action
  async activityLog2(params: any) {
    return api.activityLog2(params);
  }

  @Action
  async map(params: any) {
    return api.map(params);
  }

  @Action
  async stadium1(params: any) {
    return api.stadium1(params);
  }

  @Action
  async stadium2(params: any) {
    return api.stadium2(params);
  }

  @Action
  async stadium3(params: any) {
    return api.stadium3(params);
  }

  @Action
  async stadium4(params: any) {
    return api.stadium4(params);
  }

  @Action
  async stadium5(params: any) {
    return api.stadium5(params);
  }

  @Action
  async stadium6(params: any) {
    return api.stadium6(params);
  }

  @Action
  async stadium7(params: any) {
    return api.stadium7(params);
  }

  @Action
  async bill(params: any) {
    return api.bill(params);
  }

  @Action
  async stadiumDetail(params: any) {
    return api.stadiumDetail(params);
  }

  @Action
  async stadiumTotal(params: any) {
    return api.stadiumTotal(params);
  }

  @Action
  async stadiumAI(params: any) {
    return api.stadiumAI(params);
  }

  @Action
  async stadiumCamera(params: any) {
    return api.stadiumCamera(params);
  }

  @Action
  async graph(params: any) {
    return api.graph(params);
  }

  @Action
  async playrecordgraph(params: any) {
    return api.playrecordgraph(params);
  }

  @Action
  async playrecord(params: any) {
    return api.playrecord(params);
  }

  @Action
  async money(params: any) {
    return api.money(params);
  }

  @Action
  async statBill(params: any) {
    return api.statBill(params);
  }

  @Action
  async statUser(params: any) {
    return api.statUser(params);
  }

  @Action
  async statVip(params: any) {
    return api.statVip(params);
  }

  @Action
  async statBlock(params: any) {
    return api.statBlock(params);
  }

  @Action
  async statClub(params: any) {
    return api.statClub(params);
  }

  @Action
  async statTrain(params: any) {
    return api.statTrain(params);
  }

  @Action
  async statBindWire(params: any) {
    return api.statBindWire(params);
  }

  @Action
  async statAccount(params: any) {
    return api.statAccount(params);
  }

  @Action
  async summaryBusiness(params: any) {
    return api.summaryBusiness(params);
  }

  @Action
  async summaryManagement(params: any) {
    return api.summaryManagement(params);
  }

  @Action
  async userData(params: any) {
    return api.userData(params);
  }

  @Action
  async billType(params: any) {
    return api.billType(params);
  }

  @Action
  async stadiumground(params: any) {
    return api.stadiumground(params);
  }

  @Action
  async groundbroadcast(params: any) {
    return api.groundbroadcast(params);
  }
}
